//Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	

import React from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Grid, Typography, Box, } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import {  selectParticipantDemographicsById } from '../../../reducers/admincenter_participantdemographics';
import { selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import dayjs from 'dayjs'

// WsWebServicePlatform/help

// Participant/Phones/Get/{AuthToken}/{ParticipantGuid}/	
// Participant/Phone/Types/Get/{AuthToken}/	
// Participant/Phone/Create/{AuthToken}/{ParticipantGuid}/{ParticipantPhoneTypeGuid}/{Priority}/{PhoneNumber}/	
// Participant/Phone/Update/{AuthToken}/{ParticipantPhoneGuid}/{ParticipantPhoneTypeGuid}/{Priority}/{PhoneNumber}/	
// Participant/Phone/Delete/{AuthToken}/{ParticipantPhoneGuid}/	

// Participant/Address/Create/{AuthToken}/{ParticipantGuid}/{ParticipantAddressTypeGuid}/{Priority}/{Address1}/{Address2}/{Address3}/{City}/{StateProvinceCounty}/{PostalCode}/{CountryCode}/
// Participant/Address/Delete/{AuthToken}/{ParticipantAddressGuid}/		
// Participant/Address/Types/Get/{AuthToken}/	
// Participant/Address/Update/{AuthToken}/{ParticipantAddressGuid}/{ParticipantAddressTypeGuid}/{Priority}/{Address1}/{Address2}/{Address3}/{City}/{StateProvinceCounty}/{PostalCode}/{CountryCode}/	
// Participant/Addresses/Get/{AuthToken}/{ParticipantGuid}/	


// Participant/Misc/Update/{AuthToken}/{ParticipantMiscGuid}/{ParticipantMiscTypeGuid}/{Priority}/{MiscData}/	
// Participant/Miscs/Get/{AuthToken}/{ParticipantGuid}/	
// Participant/Misc/Delete/{AuthToken}/{ParticipantMiscGuid}/	
// Participant/Misc/Create/{AuthToken}/{ParticipantGuid}/{ParticipantMiscTypeGuid}/{Priority}/{MiscData}/

// Participant/Update/{AuthToken}/{ParticipantGuid}/{GroupGuid}/{ParticipantGroupGuid}/{LanguageID}/{LastName}/{FirstName}/{MiddleName}/{BioDOB}/{BioGender}/{BioRace}/{BioRace2}/{BioRace3}/{SpokenLanguageID}/{Email}/{StatusID}/{EducationLevelGuid}/{Medicaid}/	
// Participant/Get/{AuthToken}/{ParticipantGuid}/
// Group/Participant/Create     POST BODY: has userName	

// Participant/Merge/{AuthToken}/{SourceParticipantGuid}/{TargetParticipantGuid}/	
// Group/Participant/Move/{AuthToken}/{ParticipantGuid}/{ToGroupGuid}/	

const ParticipantDisplay = (props) => {
    const dispatch = useDispatch()
    //const Participant = props.Participant
    const LongForm = props.LongForm ? true : false
    const Participant = useSelector(state=>selectAdminParticipantById(state, props.Participant.ParticipantGuid))
    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))
    const displayDate = dayjs(Participant.LastLogin)
    const displayDateString = ( Participant.LastLogin ? ( displayDate.format("YYYY-MM-DD") + ' ' + displayDate.format("h:mm a") ) : null )

    const MainContainer = () => {
        return (
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">username: <strong>{Participant.UserName}</strong></Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">email: <strong>{ParticipantAdditionalInfo && ParticipantAdditionalInfo.Email}</strong></Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">birthday: <strong>{Participant.BioDOB}</strong></Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">group name: <strong>{Participant.GroupName}</strong></Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">last login: <strong>{displayDateString}</strong></Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                    <Typography variant="body2">status: <strong>{Participant.StatusDisplay}</strong></Typography>
                </Grid>
            </Grid>
        )
    }
    

    return (


        <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item xs={12}>
                <Box borderTop={{ xs: 1, sm: 1, md: 0 }} borderLeft={{ sm: 0, md: 1 }} p={2}>
                    <MainContainer />
                </Box>
            </Grid>
        </Grid>

    )

}
export default ParticipantDisplay
